<template>
  <v-container fluid>
    <v-row>
      <v-col class="productTile pa-1">
        <v-container>
          <v-row class="productTileRow">
            <v-col cols="12" md="6" :class="{
            'pa-0':true,
            imageMobile: ($vuetify.breakpoint.mobile | $vuetify.breakpoint.lgAndDown)
            }"
            >
              <v-img :src="image" max-height="12.6em" position="top"
                     class="pointer"
                     @click="showProduct"/>
            </v-col>
            <v-col cols="12" md="6"
                   :class="{'pa-0': ($vuetify.breakpoint.mobile | $vuetify.breakpoint.lgAndDown)}"
            >
              <v-row
                :class="{
                priceCommon: !$vuetify.breakpoint.mobile,
                priceCommonMobile: $vuetify.breakpoint.mobile,
                'no-gutters': $vuetify.breakpoint.mobile
              }"
              >
                <v-col class="text-body-1 text-line"
                       v-if="product.promotion && !$vuetify.breakpoint.mobile">
                  <div>{{ $store.state.text.common.price }}</div>
                  <div class="text-decoration-line-through">
                    {{ product.current_product_price.price_gross }}
                    {{ $store.state.text.common.currency }}
                  </div>
                </v-col>
              </v-row>
              <v-row
                :class="{
                priceForYou: !$vuetify.breakpoint.mobile && !$vuetify.breakpoint.lgAndDown,
                priceForYouMobile: ($vuetify.breakpoint.mobile),
                'mt--1': $vuetify.breakpoint.lg
              }"
              >
                <v-col>
                  <div class="text-xl-h5">{{ $store.state.text.common.priceForYou }}</div>
                  <div v-if="product.current_promotion" class="text-xl-h5">
                    <strong>
                      {{ product.current_promotion.price_gross }}
                      {{ $store.state.text.common.currency }}
                    </strong>
                    <div class="text-decoration-line-through commonPriceColor"
                         v-if="$vuetify.breakpoint.mobile">
                      {{ product.price }}
                      {{ $store.state.text.common.currency }}
                    </div>
                  </div>
                  <div v-else-if="product.current_product_price" class="text-xl-h5">
                    <strong>
                      {{ product.current_product_price.price_gross }}
                      {{ $store.state.text.common.currency }}
                    </strong>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            :class="{
              pointer: true,
              'subtitle-2': (!$vuetify.breakpoint.mobile && !$vuetify.breakpoint.lgAndDown),
              title: (!$vuetify.breakpoint.mobile && !$vuetify.breakpoint.lgAndDown),
              titleMobile: ($vuetify.breakpoint.mobile | $vuetify.breakpoint.lgAndDown)
              }"
            @click="showProduct"
          >{{ product.name }}
          </v-row>
          <v-row justify="center" class="cartButton">
            <v-btn tile color="primary" outlined
                   @click="addProductToBasket"
                   :small="$vuetify.breakpoint.mobile"
            >
              {{ $store.state.text.common.addToCart }}
            </v-btn>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Basket from '@/core/Basket';

export default {
  name: 'ProductTileNew',
  props: ['product'],
  data() {
    return {
      url: process.env.VUE_APP_URL,
      basket: new Basket(),
    };
  },
  methods: {
    showProduct() {
      this.$router.push(`/product/${this.product.slug}`);
    },
    addProductToBasket() {
      const price = this.product.current_promotion ? this.product.current_promotion.price_gross
        : this.product.current_product_price.price_gross;
      this.basket.addItemToBasket(this.product.id, this.product.name, price);
    },
  },
  computed: {
    image() {
      const ua = navigator.userAgent.toLowerCase();
      const isSafari = ua.search('Safari') >= 0 || ua.search('safari') >= 0;
      const isChrome = ua.search('Chrome') >= 0 || ua.search('chrome') >= 0;
      if (this.product.image.length === 0) {
        return '/img/norbit_nocover.png';
      }
      let imageBox = this.product.image
        .filter((value) => parseInt(value.pivot.image_type_id, 10) === 3);

      if ((isSafari && !isChrome) || imageBox.length === 0) {
        imageBox = this.product.image
          .filter((value) => parseInt(value.pivot.image_type_id, 10) === 1);
      }
      return this.url + imageBox[0].pivot.image_link;
    },
  },
};
</script>

<style scoped>
.productTile {
  background: #ffffff;
}

.productTileRow {
  margin-top: -10px;
}

.priceCommon {
  color: #9b9b9b;
  height: 4em;
}

.priceCommonMobile {
  color: #9b9b9b;
  height: 2em;
}

.commonPriceColor {
  color: #9b9b9b;
}

.priceForYou,
.priceForYouMobile,
.title,
.titleMobile {
  color: #0084cc;
}

.title {
  height: 4em;
  line-height: 1.2rem !important;
}

.titleMobile {
  height: 6.5em;
  line-height: 1rem !important;
  font-size: 10px;
}

.priceForYouMobile {
  margin-top: -2em;
  height: 6.5em;
}

.mt--2 {
  margin-top: -1em;
}

.imageMobile {
  height: 12em;
}
</style>
